import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = ["id", "name", "value", "checked"]
const _hoisted_3 = ["for"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("label", {
    class: "c-button-radio",
    for: _ctx.id
  }, [
    _createElementVNode("input", {
      id: _ctx.id,
      ref: "input",
      type: "radio",
      name: _ctx.name,
      value: _ctx.value,
      checked: _ctx.checked,
      onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onChange && _ctx.onChange(...args)))
    }, null, 40, _hoisted_2),
    _cache[1] || (_cache[1] = _createElementVNode("div", null, [
      _createElementVNode("span", { class: "c-button-radio__checkmark flex-center" }, [
        _createElementVNode("span", { class: "c-button-radio__checkmark-dot" })
      ])
    ], -1)),
    _createElementVNode("label", {
      class: "c-button-radio__label ml-8",
      for: _ctx.id
    }, [
      _renderSlot(_ctx.$slots, "default", {}, () => [
        _createTextVNode(_toDisplayString(_ctx.label || _ctx.capitalizeWord(_ctx.value, _ctx.NULL_PLACEHOLDER)), 1)
      ], true)
    ], 8, _hoisted_3)
  ], 8, _hoisted_1))
}